import { gql } from '@apollo/client';

/**
 * GraphQL mutation to update a custom label
 */
export const UPDATE_CUSTOM_LABEL = gql`
  mutation UpdateCustomLabel($communityId: ID!, $labelId: ID!, $input: UpdateCustomLabelInput!) {
    updateCustomLabel(communityId: $communityId, labelId: $labelId, input: $input) {
      label {
        id
        communityId
        name
        description
        labelType
        active
      }
    }
  }
`;
